// extracted by mini-css-extract-plugin
export default {"fleetAircraftList":"FleetAircraftList_fleetAircraftList__tEyiD","fleetAircraftEmpty":"FleetAircraftList_fleetAircraftEmpty__sDpoN"};